function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M30.96,12c2.04,0,3.7,1.66,3.7,3.7v14.6c0,2.04-1.66,3.7-3.7,3.7h-14.6c-2.04,0-3.7-1.66-3.7-3.7v-14.6c0-2.04,1.66-3.7,3.7-3.7h14.6M30.96,9h-14.6c-3.69,0-6.7,3.01-6.7,6.7v14.6c0,3.69,3.01,6.7,6.7,6.7h14.6c3.69,0,6.7-3.01,6.7-6.7v-14.6c0-3.69-3-6.7-6.7-6.7h0Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.96,12c2.04,0,3.7,1.66,3.7,3.7v14.6c0,2.04-1.66,3.7-3.7,3.7h-14.6c-2.04,0-3.7-1.66-3.7-3.7v-14.6c0-2.04,1.66-3.7,3.7-3.7h14.6M63.96,9h-14.6c-3.69,0-6.7,3.01-6.7,6.7v14.6c0,3.69,3.01,6.7,6.7,6.7h14.6c3.69,0,6.7-3.01,6.7-6.7v-14.6c0-3.69-3-6.7-6.7-6.7h0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M30.96,46c2.04,0,3.7,1.66,3.7,3.7v14.6c0,2.04-1.66,3.7-3.7,3.7h-14.6c-2.04,0-3.7-1.66-3.7-3.7v-14.6c0-2.04,1.66-3.7,3.7-3.7h14.6M30.96,43h-14.6c-3.69,0-6.7,3.01-6.7,6.7v14.6c0,3.69,3.01,6.7,6.7,6.7h14.6c3.69,0,6.7-3.01,6.7-6.7v-14.6c0-3.69-3-6.7-6.7-6.7h0Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.96,46c2.04,0,3.7,1.66,3.7,3.7v14.6c0,2.04-1.66,3.7-3.7,3.7h-14.6c-2.04,0-3.7-1.66-3.7-3.7v-14.6c0-2.04,1.66-3.7,3.7-3.7h14.6M63.96,43h-14.6c-3.69,0-6.7,3.01-6.7,6.7v14.6c0,3.69,3.01,6.7,6.7,6.7h14.6c3.69,0,6.7-3.01,6.7-6.7v-14.6c0-3.69-3-6.7-6.7-6.7h0Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/Discover-active.352e5e69.svg";
export { SvgComponent as ReactComponent };